import ProviderClinicProductTags from "./ProviderClinicProductTags";
export default ProviderClinicProductTags;
